/**
 * common路由
 */
import { RouteConfig } from 'vue-router'

const routers: RouteConfig[] = []

export default routers
